const domain = window.location.host;
let API_PATH = "";
if (domain.indexOf("developer.gartner.com") !== -1) {
  API_PATH = "https://tools.pdotoolsdev.aws.gartner.com";
}

export const Constants = {
  API: {
    API_PATH: API_PATH,
  },
  ROUTES: {
    BASE_URL: "/use-case-insights",
    USE_CASES: "/",
    DASHBOARD: "/dashboard",
    CASE_EXAMPLES: "/case-examples",
    ACCESS_DENIED: "/access-denied",
    DETAILS: "/use-case-insights/usecase",
  },
  FULL_STORY: {
    HOME_PATH: "/home",
    DASHBOARD_PATH: "/dashbooard",
  },
  ROLE: ["client", "gartner_associate"],
  GUEST_ROLE: "guest",
  CLIENT_ROLE: "client",
  GARTNER_ASSOCIATE_ROLE: "gartner_associate",
  HEADER: {
    SECONDARY_LOGO_LABEL: "AI Use Case Insights",
    SIGN_OUT: "Sign Out",
  },
  HOST: {
    PROD: "tools.pdotools.aws.gartner.com",
    QA: "tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com,",
    DEV: "tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com",
  },
  URLS: {
    GARTNER: "https://www.gartner.com",
    GARTNER_QA: "https://gcom.pdoqa.aws.gartner.com",
    GARTNER_DEV: "https://gcom.pdodev.aws.gartner.com",
  },
  PAGE_NAME: {
    POPULAR_INSIGHTS_PAGE: "Popular Insights Page",
    USE_CASE_DETAILS_PAGE: "Use Case Details Page",
  },
  ACTIS: {
    GARTNER_LOGO: {
      LABEL: "Gartner Logomark",
      ACTION: "Gartner logomark clicked on ##PAGE##",
    },
    INSIGHTS_LOGO: {
      LABEL: "Use Case Insights Platform",
      ACTION: "Use Case Insights Platform clicked on ##PAGE##",
    },
    INTERCOM_HELP: {
      LABEL: "All",
      ACTION: "Intercom Help clicked on header",
    },
  },
  HELP: {
    LABEL: "Help",
    URL: "https://intercom.help/use-case-insights/en",
  },
  TABS: ["HOME_PAGE", "USE_CASES", "SCORE_CARDS", "CASE_EXAMPLES"],
};
